import { Button, Card, Empty, List, Spin, Tag, Typography } from "antd";
import { Video } from "lucide-react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetProctoringTerms } from "@hooks";
import { getKeycloakRealm } from "@/components/helpers";

export const ProctoringTermsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading } = useGetProctoringTerms();

  return (
    <Card title={t("proctoring.termsTitle")}>
      <Spin spinning={isLoading}>
        {!isLoading && (data?.length ?? 0) === 0 ? (
          <Empty description={t("proctoring.noTerms")} />
        ) : (
          <List
            dataSource={data ?? []}
            renderItem={(term) => (
              <List.Item
                data-testid="proctoring-term"
                actions={[
                  <Button
                    key="open"
                    type="primary"
                    icon={<Video size={16} />}
                    onClick={() => navigate(`/${getKeycloakRealm}/proctoring/${term.examTermId}`)}
                  >
                    {t("proctoring.open")}
                  </Button>,
                ]}
              >
                <List.Item.Meta
                  title={term.examTitle}
                  description={dayjs(term.date).format("DD.MM.YYYY. HH:mm")}
                />
                <Typography.Text>
                  <Tag>{t("proctoring.candidates")}: {term.candidateCount}</Tag>
                  {term.assignedToMeCount > 0 && <Tag color="blue">{t("proctoring.assignedToMe")}: {term.assignedToMeCount}</Tag>}
                </Typography.Text>
              </List.Item>
            )}
          />
        )}
      </Spin>
    </Card>
  );
};
